import React from 'react';
import classNames from 'classnames';
import _range from 'lodash/range';

import jobContainerClasses from 'components/jobs/container/index.module.css';

import jobCardClasses from '../card/index.module.css';

/**
 *  Render n job card skeleton
 */
const jobCardLoader = ({ n = 4 }) =>
  _range(1, n + 1, 1).map((item) => (
    <div
      className={classNames(jobContainerClasses.bucketListItem, 'bucketListItem loadedBucketJobs')}
      key={`loader${item}`}
    >
      <div className="bucketListItemLogo">
        <div className="CompanyLogo generic-company-logo xsmall animate-flicker" />
      </div>
      <div
        className={classNames(
          jobCardClasses.bucketListItemContent,
          'bucketListItemContent loadingBucket'
        )}
      >
        <div className="animate-flicker firstRowLB" />
        <div className="animate-flicker secondRowLB" />
        <div className="animate-flicker thirdRowLB" />
        <div className="animate-flicker fourthRowLB" />
        <div className="animate-flicker fifthRowLB" />
        <div className="animate-flicker sixthRowLB" />
      </div>
    </div>
  ));

export default jobCardLoader;
